import { isJson } from "../utils/tools";

/*
1.sessionStorage特定于页面的协议，不是同一域名，不能访问。
2.有长度限制，5M左右，不同浏览器大小会有不同。
3.生命周期是永久的，但是数据实际是存在浏览器的文件夹下，可能卸载浏览器就会删除。
4.浏览器可以设置是否可以访问数据，如果设置不允许会访问失败。
5.兼容IE8以上浏览器
6.只能存储字符串类型，需要转成字符串存储。
----------------------------------------------
1.先判断浏览器是否支持sessionStorage，通过if(!window.sessionStorage) return;
2.单词太长，不方便书写，可以利用 var storage=window.sessionStorage;
3.字符串和原始类型需要通过JSON.stringfy转字符串，通过JSON.parse转成对象
4.通过封装方法实现来回转化--只能存储字符串
**/
const sStorage = {
  setKey(key, value) {
    if(isJson(value) || Array.isArray(value)){
      sessionStorage.setItem(key, JSON.stringify(value));
      return;
    }
    sessionStorage.setItem(key, value);
  },

  setKeyJsonStr(key, value) {
    sessionStorage.setItem(key, JSON.stringify(value));
  },

  //key若是json数据，只更新其中一部分
  updateKeyJson(key, subKey, value) {
    let json = {}
    try{
      json = JSON.parse(sessionStorage.getItem(key))
    }catch(e){
      ;
    }
    if(!json) json={};
    json[subKey] = value;//不用存字符，直接存值JSON.stringify(value);
    //sessionStorage.setItem(key, json);
    // json[subKey] = value;
    // sessionStorage.setItem(key, json);
    this.setKeyJsonStr(key, json)
  },

  updateSonJson(key:string, subKey:string, subSubKey:string, value:any) {
    let json = {}
    try{
      json = JSON.parse(sessionStorage.getItem(key))
    }catch(e){
      ;
    }
    if(!json){
      json={};
      json[subKey] = {};
      json[subKey][subSubKey] = {};
    } else {
      if(!json[subKey]){
        json[subKey] = {};
        json[subKey][subSubKey] = {};
      }
    }

    json[subKey][subSubKey] = value;//不用存字符，直接存值JSON.stringify(value);
    this.setKeyJsonStr(key, json)
  },

  //key若是json数据，只取出其中一部分
  getsubKey(key:string, subKey:string) {
    let v = this.getKeyJson(key);
    if(v){
      return v[subKey];
    }
    return v;
  },

  getKey2Str(key) {
    return sessionStorage.getItem(key);
  },
  getKey2Num(key) {
    let kv = sessionStorage.getItem(key);
    if(kv === null || kv === undefined)return kv;
    return Number(kv);
  },
  getKey2Json(key:string) {
    if(key){
      let item = sessionStorage.getItem(key);
      if(item  && item.length > 0 && item !== 'undefined'  && item !== 'null'){
        return JSON.parse(item);
      }
    }
    return undefined;
  },
  getKey2JsonWithSub(key:string, sub:string) {
    let js = this.getKey2Json(key);
    if(js){
      return js[sub];
    }
    return undefined;
  },

 getSonKey2JsonWithSub(key:string, sub:string, subSub:string) {
    let js = this.getKey2Json(key);
    if(js){
      if(js[sub] && js[sub][subSub]) {
        return js[sub][subSub];
      }
    }
    return undefined;
  },

  rmvKey(key) {
    sessionStorage.removeItem(key);
  },


  /**获取所有的key*/
  keys(){
    //let size = sessionStorage.length;
    let arr = [];
    for (let i = 0, j= sessionStorage.length; i<j; i++) {
      arr[i] = sessionStorage.key(i);
    }
    return arr;
  },

  /**实现某些用户的特定缓存的清理*/
  clearByPrefix(prefix:string) {
    if(prefix === undefined || prefix === null || prefix.length === 0){
        sessionStorage.clear();
    }else{
      let key:string;
      for (let i = 0, j= sessionStorage.length; i<j; i++) {
        key = sessionStorage.key(i);
        try{
          if(key !== null && key !== undefined){
            if(key.startsWith(prefix)){
              sessionStorage.removeItem(key);
            }
          }
        }catch(e){//之前有异常未捕获
          console.error(e);
        }
      }
    }
  }
};

export default sStorage;
